import React, { FC, useEffect, useState, useRef } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { ModalContentProps } from '../../Modal'
import Skeleton from 'react-loading-skeleton'
import { YellowButton } from '../../YellowButton'
import { createNewTemplate, getAllTemplates} from '../../../features/templates/templatesSlice'
import { CartItem } from '../../ListItems/CartItem'
import useTheme from '../../../hooks/useAppColor'
import { encodeURL, URL_TEMPLATE } from '../../../utils/hashURLData'
import { handleTemplateSheetCreateModal } from '../../../features/modals/modalsSlice'
import { NoticeType } from 'antd/es/message/interface'
import { message } from 'antd';


export const CreateTemplateSheetModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()

    const cartProducts = useAppSelector(state => state.cart.items)
    const cartTotalPrice = useAppSelector(state => state.cart.totalPrice)
    const [inputValue, setInputValue] = useState<string>('');
    const userID = useAppSelector(state => state.profile.profile_id)
    const agent_id = useAppSelector(state => state.profile.profile_id)
    const [messageApi, contextHolder] = message.useMessage();
    

   
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    const showMessage = (type: NoticeType, content: string) => {
        messageApi.open({
          type: type,
          content: <div style={{ whiteSpace: 'normal', direction: 'ltr' }}>{content}</div>,
          duration: 15
        });
      };


    const handleCreate = () => {

        const id = encodeURL(userID)
        
        const reqData = {
            agent_id: userID,
            title: inputValue,
            analysis: cartProducts.map(item => item.id),
            url: `${URL_TEMPLATE.templateGet}name=${inputValue.replace(/\s+/g, "+")}&id=${id}`
        }

        dispatch(createNewTemplate(reqData))
        dispatch(getAllTemplates({agent_id: agent_id}))
        dispatch(handleTemplateSheetCreateModal())
        showMessage("success", `Шаблон успешно сохранен!`)

        
    }

    

    return (
        <BorderedPageLayout
            modal={{ level: level || 1 }}
            handleModal={handleModal}
            contentClassName='f-column gap-40'>
            <div className="d-f jc-between">
                <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
                <div className='f-025'></div>
            </div>
            <div className={`d-f pd-10 al-center gap-5 search-block w-100p ${getTheme("", "app-bg-dark svg-gray-filled")}`}>
                <input  onChange={handleInputChange} className={`w-100p fz-m ${getTheme("", "c-white")}`} type="text" placeholder='Введите название шаблона' />
            </div>
            <div className="f-column gap-15 f-1">
                <div className="f-1 p-rel">     
                    <div className="list p-abs w-100p f-column scrollableItemsList gap-10">
                        {
                            cartProducts.map(item => (
                                <CartItem
                                    item={item}
                                    del={false} />
                            ))
                        }
                    </div>
                </div>

                <div className="p-rel">
                    <p className={`${getTheme("c-dark", "c-white")} fz-l fw-9`}>Итого: {cartTotalPrice}&nbsp;₽</p>
                </div>


                <YellowButton disabled={(inputValue === "")} className='f-c-row gap-10' onClick={handleCreate}>Сохранить шаблон</YellowButton>

            </div>
        </BorderedPageLayout>
    )
}
